export default __webpack_public_path__ + "static/media/resultsHero.9498c449.webp";